import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { checkAccount } from '../bridge';
import '../styles/Auth.css';

const logo = require('../logo.jpeg');

const AccountRecovery = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const validateEmail = (e) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!validateEmail(email)) {
      setError('Please enter a valid email address.');
      return;
    }
    setLoading(true);
    const exists = await checkAccount(email.trim().toLowerCase());
    setLoading(false);
    if (!exists) {
      setError('No account found with that email address.');
      return;
    }
    navigate('/account-recovery/verify', {
      state: { email: email.trim().toLowerCase(), mode: 'recover' },
    });
  };

  return (
    <div className="auth-page">
      <nav className="navbar">
        <div className="navbar-inner">
          <Link to="/login" className="navbar-brand">
            <img src={logo} className="navbar-logo" alt="Menu & Catalog Maker" />
            <span className="navbar-title">Menu &amp; Catalog Maker</span>
          </Link>
        </div>
      </nav>

      <div className="auth-body">
        <div className="auth-card">
          <h1 className="auth-card-title">Forgot password?</h1>
          <p className="auth-card-subtitle">
            Enter your account email and we'll walk you through verifying your identity.
          </p>

          {error && <div className="auth-error">{error}</div>}

          <form onSubmit={handleSubmit} noValidate>
            <div className="auth-field">
              <label className="auth-label">Email</label>
              <input
                className="auth-input"
                type="email"
                placeholder="you@example.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
                autoComplete="email"
              />
            </div>
            <button className="auth-submit" type="submit" disabled={loading}>
              {loading ? 'Checking…' : 'Continue'}
            </button>
          </form>

          <div className="auth-link-row">
            <Link to="/login" className="auth-link">Back to log in</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountRecovery;
